const AlertPopupModal: React.FC<{
  isVisible?: boolean;
  position: { top?: number; left?: number } | null;
  OnReadClick?: (e: any) => void;
  OnUnreadClick?: (e: any) => void;
  OnDeleteClick?: (e: any) => void;
}> = ({ isVisible, position, OnReadClick, OnUnreadClick, OnDeleteClick }) => {
  if (!position) return null; // Prevents rendering when position is null

  return (
    <div
      className="p-3 modal-bg alert-modal"
      style={{
        top: position.top,
        left: position.left,
        zIndex: 1,
        animation: isVisible ? "slideInFromRight 1s ease-out" : "slideOutToLeft 1.6s ease-out", // Apply appropriate animation based on visibility
      }}
    >
      <div className="font-inter-400-15 normal" onClick={OnReadClick}>
        Mark as read
      </div>
      <div className="font-inter-400-15 normal" onClick={OnUnreadClick}>
        Mark as unread
      </div>
      <div className="font-inter-400-15 danger border-top-custom" onClick={OnDeleteClick}>
        Delete Alert<i className="fa-solid fa-trash-can ms-2"></i>
      </div>
    </div>
  );
};

export default AlertPopupModal;
